import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import AppShell from "@/components/AppShell";
import { Loading } from "@/components/common";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import OrderCenter from "@/pages/OrderCenter";
import POS from "@/pages/POS";
import Checkout from "@/pages/Checkout";
import Kanban from "@/pages/Kanban";
import Products from "@/pages/Products";
import Materials from "@/pages/Materials";
import Inventory from "@/pages/Inventory";
import Customers from "@/pages/Customers";
import Receivables from "@/pages/Receivables";
import Reports from "@/pages/Reports";
import ProfitReport from "@/pages/ProfitReport";
import Branches from "@/pages/Branches";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Attendance from "@/pages/Attendance";
import Care from "@/pages/Care";
import DailyReport from "@/pages/DailyReport";
import Freshness from "@/pages/Freshness";
import MaterialUsage from "@/pages/MaterialUsage";
import Commissions from "@/pages/Commissions";
import Roles from "@/pages/Roles";
import AuditLog from "@/pages/AuditLog";
import Notifications from "@/pages/Notifications";
import WhatsApp from "@/pages/WhatsApp";
import Waste from "@/pages/Waste";
import Opname from "@/pages/Opname";
import Transfers from "@/pages/Transfers";
import Shipments from "@/pages/Shipments";
import SupplierDebts from "@/pages/SupplierDebts";
import Consignment from "@/pages/Consignment";
import Cashbook from "@/pages/Cashbook";
import Accounting from "@/pages/Accounting";
import AccountingReport from "@/pages/AccountingReport";
import PaymentMethods from "@/pages/PaymentMethods";
import Calendar from "@/pages/Calendar";
import Preorders from "@/pages/Preorders";
import SalesReport from "@/pages/SalesReport";
import StockDaily from "@/pages/StockDaily";
import Bulk from "@/pages/Bulk";
import Printer from "@/pages/Printer";
import StockReport from "@/pages/StockReport";
import StockMovements from "@/pages/StockMovements";
import StockCard from "@/pages/StockCard";
import InventoryDashboard from "@/pages/InventoryDashboard";
import InventoryControlReport from "@/pages/InventoryControlReport";
import VoidReport from "@/pages/VoidReport";
import PaymentReport from "@/pages/PaymentReport";
import DailyUsage from "@/pages/DailyUsage";
import BusinessUnitPnl from "@/pages/BusinessUnitPnl";
import OpnameApproval from "@/pages/OpnameApproval";
import ConsignmentReport from "@/pages/ConsignmentReport";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <Loading label="Menyiapkan aplikasi..." />;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function LoginRoute() {
  const { user, ready } = useAuth();
  if (!ready) return <Loading />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

const routes = [
  ["/", Dashboard],
  ["/pos", POS],
  ["/checkout", Checkout],
  ["/order-center", OrderCenter],
  ["/kanban", Kanban],
  ["/calendar", Calendar],
  ["/preorders", Preorders],
  ["/whatsapp", WhatsApp],
  ["/products", Products],
  ["/materials", Materials],
  ["/inventory", Inventory],
  ["/shipments", Shipments],
  ["/transfers", Transfers],
  ["/opname", Opname],
  ["/waste", Waste],
  ["/stock-daily", StockDaily],
  ["/stock-report", StockReport],
  ["/stock-movements", StockMovements],
  ["/stock-card", StockCard],
  ["/inventory-dashboard", InventoryDashboard],
  ["/inventory-control-report", InventoryControlReport],
  ["/daily-usage", DailyUsage],
  ["/opname-approval", OpnameApproval],
  ["/consignment", Consignment],
  ["/customers", Customers],
  ["/receivables", Receivables],
  ["/supplier-debts", SupplierDebts],
  ["/cashbook", Cashbook],
  ["/accounting", Accounting],
  ["/accounting-report", AccountingReport],
  ["/reports", Reports],
  ["/profit-report", ProfitReport],
  ["/payment-report", PaymentReport],
  ["/void-report", VoidReport],
  ["/bu-pnl", BusinessUnitPnl],
  ["/consignment-report", ConsignmentReport],
  ["/sales-report", SalesReport],
  ["/commissions", Commissions],
  ["/attendance", Attendance],
  ["/care", Care],
  ["/daily-report", DailyReport],
  ["/freshness", Freshness],
  ["/material-usage", MaterialUsage],
  ["/notifications", Notifications],
  ["/branches", Branches],
  ["/users", Users],
  ["/roles", Roles],
  ["/payment-methods", PaymentMethods],
  ["/printer", Printer],
  ["/audit-log", AuditLog],
  ["/bulk", Bulk],
  ["/settings", Settings],
];

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            {routes.map(([path, Comp]) => (
              <Route key={path} path={path} element={<Protected><Comp /></Protected>} />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
